<template>
 <div>
  <SummaryHead summaryClass="-highperformer">
    <template v-slot:title01>{{pagetitle}}</template>
    <template v-slot:txt>
どんな業界にでも、どうやってこんなに契約が取れるんだろう、と不思議に思ってしまうほどのパフォーマンスを発揮するセールスパーソンがいます。<br>
人と話すことが得意で、いつも自信に満ちている、そんなイメージのあるハイパフォーマーですが、いったいどのどのくらい外向的で、どのくらい自信があれば彼らに近づけるのでしょうか。<br>
実際にハイパフォーマーと成績中・下位層の人物特性を比べて、それぞれの違いをのぞいてみましょう。

    </template>
  </SummaryHead>

  <div class="contents-block">

    <section class="summary-section">
      
      <h2 class="ttlbar _mw1000">ハイパフォーマーと成績中・下位層の人物特性比較</h2>

      <div class="sminner">

        <div class="linbarblock">
          <div class="linbarblockinner">
            <LineBar></LineBar>
          </div>
          <div class="chartitems">
            <div class="expitem"><span class="toptobtm">差の大きさ</span></div>
            <div class="expitem"><span class="blueline">上位層</span><span class="redline">中・下位層</span></div>
          </div>
          <p class="_mb80">
            この図では、中・下位層の平均点を青線、上位層の平均点を赤線で示しており、棒グラフはそれぞれの平均の差を表しています。どの項目でも少なからず違いがありますが、特にグラフ中央辺りの項目で大きな差があることが分かります。これらの項目は人物の行動特性を表しており、上位層と中・下位層では行動パターンやコミュニケーションの取り方に違いがあることが読み取れます。
          </p>
        </div><!-- .linbarblock -->

        <h3 class="smttlm _trgbtmct">特に差が大きかった、主導型、社交型、安定型の項目について詳しく見ていきましょう。</h3>

        <div class="linbarblock">
          <div class="ebcover" id="ebData">
            <component :is="componentName" :ebardata="ebardata"></component>
          </div>
        </div><!-- .linbarblock -->

        <h4 class="smttls">ハイパフォーマーは主導型と社交型で中・下位層を大きく上回っています。</h4>
        <p class="smtxt _mb40">
          新規顧客を獲得するためのチャレンジ精神や、部署全体で目標達成を目指す団結力は営業に必須の能力と一般的に言われていますが、実際にハイパフォーマーはそれらの能力に長けていることがデータに表れています。<br>
          一方で中・下位層は安定型の平均点がハイパフォーマーの倍近く高いことが分かります。<br>
          営業活動においてサポートが得意な人物は不可欠ではありますが、営業成績に対してポジティブな影響があるとは言い難いようです。
        </p>

      </div><!-- .sminner -->

      <SummaryBottom></SummaryBottom>

    </section>

    <RelatedContents :contentsNum="3"></RelatedContents>

  </div><!-- contents-block -->
 </div>

</template>


<script>
import SummaryHead from "../components/SummaryHead.vue";
import SummaryBottom from "../components/SummaryBottom.vue";

import LineBar from "../components/LineBar.vue";
import ErrorBar from "../components/ErrorBar.vue";
import RelatedContents from "../components/RelatedContents.vue";

export default {
  components: {
    LineBar,
    ErrorBar,
    RelatedContents,
    SummaryHead,
    SummaryBottom
  },
  data() {
    return {
      pagetitle:"ハイパフォーマー特性",
      componentName: "",
      posinegadata: [
        { num: 1, name: "内向的", name2: "外向的", red: -1, blue: 0.5 },
        { num: 2, name: "消極的", name2: "積極的", red: 1, blue: -0.3 },
        {
          num: 3,
          name: "ネガティブ",
          name2: "ポジティブ",
          red: -0.4,
          blue: 0.8,
        },
      ],
      ebardata: [
        {
          num: 1,
          name: "主導型",
          exp: "意識が高く、何事にも挑戦し貪欲に結果を求める",
          red: 62.2,
          blue: 41.2,
          eRed: 4.6,
          eBlue: 4.1,
        },
        {
          num: 2,
          name: "社交型",
          exp: "仲間で協力したり、楽しみながら物事を進めることを好む",
          red: 63.4,
          blue: 40.4,
          eRed: 4.4,
          eBlue: 4.1,
        },
        {
          num: 3,
          name: "安定型",
          exp: "聞き上手で、陰ながら支援するサポート役を好む",
          red: 36.4,
          blue: 59.7,
          eRed: 4.4,
          eBlue: 4.1,
        },
      ],
    };
  },
  methods: {
    handleScroll: function () {
      let targetElement = document.getElementById( "ebData" ) ;
      let clientRect = targetElement.getBoundingClientRect() ;
      let border = window.pageYOffset + window.innerHeight;
      if (border >= clientRect.top) {
        this.componentName= "ErrorBar"
      }else{
        this.componentName= ""
      }
    }    
  }, 
  mounted: function () {
    window.addEventListener("scroll", this.handleScroll);
    document.querySelector("meta[name='description']").setAttribute('content', "優秀層（ハイパフォーマー）と成績中・下位層の人物特性比較。人と話すことが得意で、いつも自信に満ちている、そんなイメージのあるハイパフォーマーですが、いったいどのどのくらい外向的で、どのくらい自信があれば彼らに近づけるのでしょうか。実際にハイパフォーマーと成績中・下位層の人物特性を比べて、それぞれの違いをのぞいてみましょう。");
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },   
  metaInfo: {
    title: "ハイパフォーマー特性 | 人気10業界！営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },

};
</script>